/* src/app/logout/logout.component.css */
#logoutContainer {
  background-color: #f2f2f2;
  padding: 20px;
}
/*# sourceMappingURL=logout.component.css.map */
